<template>
  <div class="home">
    <dl class="tabular headings">
      <dt class="blank">
        <SearchDestiny />
      </dt>
      <template v-if="players && players.length">
        <dl v-for="player in players" :key="player.key" class="dh has-characters">
          <dt>{{ player.name }}</dt>
          <dd>
            <ul v-if="player.profile.characters && manifestLoaded" class="characters">
              <li v-for="character in player.profile.characters.data" :key="character.characterId">
                <img :src="domain + character.emblemPath" :title="classDef(character.classHash).displayProperties.name">
              </li>
            </ul>
            <ul class="hover-menu">
              <li>
                <button title="Refresh" @click="refreshClick(player.type, player.id)">⟳</button>
              </li>
              <li>
                <button title="Remove" @click="removeClick(player.key)">&times;</button>
              </li>
            </ul>
            <div v-if="refreshingPlayer(player.id)" class="refresh">
              <div>
                <span class="spinner"></span>
                Refreshing...
              </div>
            </div>
          </dd>
        </dl>
      </template>
      <dl v-else>
        <dd>
          Please search for Gamertags to add players.
        </dd>
      </dl>
    </dl>
    <dl class="tabular">
      <dt>Last Played</dt>
      <dl v-for="player in players" :key="player.key">
        <dt>{{ player.name }}</dt>
        <dd v-if="player.profile && player.profile.profile.data">
          {{ player.profile.profile.data.dateLastPlayed.split('T')[0] }}
        </dd>
      </dl>
    </dl>
    <dl class="tabular">
      <dt>Hours Played</dt>
      <dl v-for="player in players" :key="player.key" class="has-characters">
        <dt>{{ player.name }}</dt>
        <dd>
          <ul v-if="player.profile.characters && manifestLoaded" class="characters small">
            <li v-for="character in player.profile.characters.data" :key="character.characterId">
              {{ Math.round(character.minutesPlayedTotal / 60) }}
            </li>
          </ul>
          <div v-if="player.profile.characters && manifestLoaded" class="total">
            {{ totalMinutesPlayed(player) }}
          </div>
        </dd>
      </dl>
    </dl>
    <dl class="tabular">
      <dt>Season Rank + Power Bonus</dt>
      <dl v-for="player in players" :key="player.key">
        <dt>{{ player.name }}</dt>
        <dd>
          <template v-if="manifestLoaded">
            {{ seasonRank(player) }}
          </template>
          <template v-if="player.profile.profileProgression">
            + {{ player.profile.profileProgression.data.seasonalArtifact.powerBonus }}
          </template>
        </dd>
      </dl>
    </dl>
    <dl class="tabular">
      <dt>Light Level</dt>
      <dl v-for="player in players" :key="player.key" class="has-characters">
        <dt>{{ player.name }}</dt>
        <dd>
          <ul v-if="player.profile.characters && manifestLoaded" class="characters">
            <li v-for="character in player.profile.characters.data" :key="character.characterId" class="column">
              <span class="xsmall">
                {{ character.light - player.profile.profileProgression.data.seasonalArtifact.powerBonus }} + 
                {{ player.profile.profileProgression.data.seasonalArtifact.powerBonus }}
              </span>
              <span>{{ character.light }}</span>
            </li>
          </ul>
        </dd>
      </dl>
    </dl>
    <dl class="tabular">
      <dt>Triumph Score</dt>
      <dl v-for="player in players" :key="player.key">
        <dt>{{ player.name }}</dt>
        <dd v-if="player.profile && player.profile.profile.data">
          {{ Number(player.profile.profileRecords.data.score).toLocaleString() }}
        </dd>
      </dl>
    </dl>
    <div v-if="manifestLoaded && settings" class="nodes">
      <Node v-if="settings.destiny2CoreSettings" 
        :table="'DestinyPresentationNodeDefinition'"
        :hash="settings.destiny2CoreSettings.recordsRootNode" :level="1"
      />
      <Node v-if="settings.destiny2CoreSettings" 
        :table="'DestinyPresentationNodeDefinition'"
        :hash="settings.destiny2CoreSettings.collectionRootNode" :level="1" 
      />
      <Node v-if="settings.destiny2CoreSettings" 
        :table="'DestinyPresentationNodeDefinition'"
        :hash="settings.destiny2CoreSettings.badgesRootNode" :level="1" 
      />
      <Node v-if="settings.destiny2CoreSettings" 
        :table="'DestinyPresentationNodeDefinition'"
        :hash="settings.destiny2CoreSettings.activeSealsRootNodeHash" :level="1" 
      />
      <Node v-if="settings.destiny2CoreSettings" 
        :table="'DestinyPresentationNodeDefinition'"
        :hash="settings.destiny2CoreSettings.seasonalChallengesPresentationNodeHash" :level="1" 
      />
      <Node v-if="settings.destiny2CoreSettings" 
        :table="'DestinyPresentationNodeDefinition'"
        :hash="settings.destiny2CoreSettings.exoticCatalystsRootNodeHash" :level="1" 
      />
      <Node v-if="settings.destiny2CoreSettings" 
        :table="'DestinyPresentationNodeDefinition'"
        :hash="settings.destiny2CoreSettings.medalsRootNodeHash" :level="1" 
      />
      <Node v-if="settings.destiny2CoreSettings" 
        :table="'DestinyPresentationNodeDefinition'"
        :hash="settings.destiny2CoreSettings.loreRootNodeHash" :level="1" 
      />
      <Node v-if="settings.destiny2CoreSettings" 
        :table="'DestinyPresentationNodeDefinition'"
        :hash="settings.destiny2CoreSettings.metricsRootNode" :level="1" 
      />
      <Node v-if="settings.destiny2CoreSettings" 
        :table="'DestinyPresentationNodeDefinition'"
        :hash="settings.destiny2CoreSettings.legacyTriumphsRootNodeHash" :level="1" 
      />
      <Node v-if="settings.destiny2CoreSettings" 
        :table="'DestinyPresentationNodeDefinition'"
        :hash="settings.destiny2CoreSettings.legacySealsRootNodeHash" :level="1" 
      />
    </div>
    <div v-if="statusMessage && statusMessage.text" :class="'status-message ' + statusMessage.css">
      <span v-if="statusMessage.spinner" class="spinner"></span>
      <span>
        {{statusMessage.text}}
      </span>  
    </div>
    <!-- debug -->
    <div v-if="manifestLoaded" class="debug">
      {{ settings.destiny2CoreSettings }}
      <li v-for="player in players" :key="player.key">
        {{ player.id }}
      </li>
    </div>
    <div v-if="debugMessage" style="white-space:pre">{{ debugMessage }}</div>
  </div>
</template>

<style lang="scss">
@import "@/styles/global.scss";
#app {
  width: 100vw;
  max-height: 100vh;
  overflow: auto;
  margin: -8px -8px;
}

.home {
  display: inline-block;
  width: auto;
}

.headings {
  position: sticky;
  top: 0;
  z-index: 2;
}

.loading {
  width: 100%;
  min-width: $dt-width;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 150%;
}

.tabular {
  display: flex;
  width: 100%;
  margin: 0;
  &.leaf {
    > dt, > dl > dd {
      background: $dark-background;
    }
  }

  .blank {
    min-height: 90px;
    background: $body-background;
  }
  .dh {
    padding: 0;
    display: flex;
    flex-direction: column;
    > dt {
      display: flex;
      padding: 5px;
      justify-content: center;
      min-height: 0;
      background: $dark-background;
      border-bottom: none;
    }
    > dd {
      padding-left: 0;
      padding-right: 0;
      border: none;
    }
    ul {
      border-top: $cell-border;
    }
  }
  .has-characters {
    position: relative;
    padding: 0;
    &:hover {
      .hover-menu {
        visibility: visible;
      }
    }
    ul {
      display: flex;
      width: 100%;
      height: 100%;
      list-style: none;
      margin: 0;
      padding: 0;
    }
    ul.characters {
      li {
        display: flex;
        flex-basis: 33.3%;
        justify-content: center;
        align-items: center;
        border-right: $cell-border;
        &:nth-of-type(3) { border-right: none; }
        img {
          width: 59px;
          height: 59px;
          max-width: 100%;
        }
      }
    }
    ul.hover-menu {
      visibility: hidden;
      position: absolute;
      background: #229966;
      top: 0;
      right: 0;
      height: auto;
      width: auto;
      button {
        background: rgba(0, 0, 0, 0.5);
        margin: 5px;
        border: none;
        color: #eeeeee;
        font-size: 1.2rem;
        cursor: pointer;
        &:hover {
          background: #BB6622;
        }
      }
    }
    .refresh {
      display: flex;
      justify-content: center;
      align-items: center;
      position: absolute;
      background: rgba(255, 255, 2550, 0.9);
      color: #111111;
      left: 0;
      top: 0;
      right: 0;
      bottom: 0;
      .spinner {
        border-color:#111111;
      }
    }
  }

  dl {
    display: flex;
    margin: 0;
  }

  dt, dd {
    @extend .cell;
    display: flex;
    align-items: center;
    padding: 0;
    padding-left: $cell-padding;
    padding-right: $cell-padding;
    margin: 0;
    min-height: 47px;
    .small {
      font-size: 75%;
      color: #aaaaaa;
      margin: 0;
    }
    .xsmall {
      font-size: 70%;
      color: #888888;
    }
    .hidden {
      font-size: 60%;
      color: #888888;
    }
    .progress {
      font-size: 60%;
      color: #778877;
    }
  }
  > dt {
    width: $dt-width;
    margin-left: 0.5rem;
    position: sticky;
    left: 0.5rem;
    background: $header-background;
    z-index: 1;
  }
  
  > dl {
    > dt {
      display: none;
    }
    > dd {
      width: $dd-width;
      overflow: hidden;
      flex-direction: column;
      justify-content: center;
      text-align: center;
      &.number {
        justify-content: flex-end;
      }
    }
  }
  
  .column {
    display:flex; 
    flex-direction: column;
    span:first-of-type {
      border-bottom: $cell-border;
    }
  }
  .small {
      font-size: 80%;
      flex-basis: 50%;
    }
  .total {
    display: flex;
    justify-content: center;
    flex-basis: 60%;
    width: 100%;
    border-top: $cell-border;
  }
}

// portrait
@media screen and(max-device-width: $mobile-max-width) and (orientation: portrait) {
  .home {
    display: block;
  }
  .tabular {
    display: block;
    &.headings {
      position: static;
    }
    .blank {
      min-height: 0;
      border: none;
      padding-bottom: 5px;
    }
    .search {
      position: static;
    }
    .dh {
      background: $cell-background;
      margin-bottom: 5px;
      > dd {
         width: auto;
      }
    }
    dl {
      > dt, > dd { 
        display: flex; 
        flex-basis: 50%;
        min-height: 30px;
      }
    }
    > dt {
      width: 100%;
      position: static;
    }
  }
}

// landscape
//@media screen and (max-device-width: $mobile-max-width) and (orientation: landscape) {
  
//}
</style>

<script>
import { mapState } from 'vuex'
import * as api from '@/api'
import manifest from '@/utils/manifest';
import * as general from '@/utils/general'
import Node from "@/components/Node";
import SearchDestiny from "@/components/SearchDestiny";

export default {
  name: "Home",
  data() {
    return {
      showChildren: false,
      node: [],
      domain: api.URL_DOMAIN,
      manifest: manifest
    }
  },
  computed: {
    ...mapState(['settings', 'players', 'statusMessage', 'manifestLoaded', 'debugMessage']),
    playerParams() {
      if (this.$route.params.players) {
        return this.$route.params.players.split('/');
      }
      return [];
    }
  },
  components: {
    Node,
    SearchDestiny
  },
  watch: {
    $route() {
      general.readPlayers();
      manifest.readAll();
    }
  },
  methods: {
    classDef(classHash) { 
      return manifest.DestinyClassDefinition[classHash]; 
    },
    totalMinutesPlayed(player) {
      let total = 0;
      for(const characterId in player.profile.characters.data) {
        total += player.profile.characters.data[characterId].minutesPlayedTotal / 60;
      }
      return Math.round(total);
    },
    seasonRank(player) {
      const season = manifest.DestinySeasonDefinition[this.settings.destiny2CoreSettings.currentSeasonHash];
      const seasonPass = manifest.DestinySeasonPassDefinition[season.seasonPassHash];
      const characterId = Object.keys(player.profile.characters.data)[0];
      const progressions = player.profile.characterProgressions.data[characterId].progressions;
      const rewardLevel = progressions[seasonPass.rewardProgressionHash] && progressions[seasonPass.rewardProgressionHash].level;
      const prestigeLevel = progressions[seasonPass.prestigeProgressionHash] && progressions[seasonPass.prestigeProgressionHash].level;
      return rewardLevel + prestigeLevel;
    },
    refreshClick(membershipType, membershipId) {
      general.refreshPlayer(membershipType, membershipId);
    },
    refreshingPlayer(membershipId) {
      return this.$store.state.refreshingPlayers && this.$store.state.refreshingPlayers.indexOf(membershipId) > -1;
    },
    removeClick(key) {
      general.removePlayer(key);
    },
  },
  async mounted() {
    general.readPlayers();
    manifest.readAll();
  }
  
};
</script>